import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=7ebe7fe8&scoped=true&"
import script from "./CopyText.vue?vue&type=script&lang=js&"
export * from "./CopyText.vue?vue&type=script&lang=js&"
import style0 from "./CopyText.vue?vue&type=style&index=0&id=7ebe7fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebe7fe8",
  null
  
)

component.options.__file = "CopyText.vue"
export default component.exports